import { ArrowBigDown, ArrowBigUp } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "../../../../../../shared/components/tooltip/Tooltip";
import { useTranslation } from "react-i18next";

const ObjectivesTrackerArrowIndicator = ({ difference }) => {
  const { t } = useTranslation();

  const renderProperIcon = () => {
    if (difference === "NaN") {
      return <></>;
    }

    const icon =
      difference < 0 ? (
        <ArrowBigDown fill="#0068ff" color="#0068ff" />
      ) : (
        <ArrowBigUp fill="#0068ff" color="#0068ff" />
      );

    const content =
      difference < 0
        ? t("objectivesTracker.detail.arrowIndicator.under")
        : t("objectivesTracker.detail.arrowIndicator.over");

    return (
      <Tooltip>
        <TooltipTrigger>{icon}</TooltipTrigger>
        <TooltipContent>{content}</TooltipContent>
      </Tooltip>
    );
  };
  return renderProperIcon();
};

export default ObjectivesTrackerArrowIndicator;
